// extracted by mini-css-extract-plugin
export default {"container":"CheckboxInput_container__bEesJ","round":"CheckboxInput_round__xWbH-","hiddenLabel":"CheckboxInput_hiddenLabel__FMuJp"};